import { noModal } from 'components/automations/components/modals';
import CloseChatModal from 'components/powerChatFlow/components/modals/hidden';
import CloseEmailModal from 'components/powerEmailFlow/components/modals/close';
import { flowNodeColor } from 'fable/flowEditor';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import type { CanvasExtraData } from 'flow-builder/types/extraData';
import type {
  GenericNodeAttributes,
  GenericNodeProps,
} from 'flow-builder/types/node';
import { AutomationNodeTypes } from 'hocs';

import { FlowNodeTypes } from '../../types';

export type CloseNodeAttributes = GenericNodeAttributes<
  unknown,
  CanvasExtraData
>;
export type CloseNodeProps = GenericNodeProps<unknown, CanvasExtraData>;

export const createCloseNodeAttributes = (attributes: {
  iconName: CloseNodeAttributes['iconName'];
  label: CloseNodeAttributes['label'];
  ActionModal?: CloseNodeAttributes['ActionModal'];
  helpText?: CloseNodeAttributes['helpText'];
}): CloseNodeAttributes => ({
  color: hexStringToNumber(flowNodeColor.red),
  translatePayload: () => [],
  updateConnection: (node) => node,
  NodeContent: CloseNode,
  isEditable: false,
  ...attributes,
});

export const CloseNodeEmailAttributes = createCloseNodeAttributes({
  iconName: 'close-circle-filled',
  label: 'Close',
  ActionModal: CloseEmailModal,
  helpText:
    'Close the conversation entirely when it matches predetermined criteria (e.g. after a filter or tag is applied, after an auto-reply is sent, etc.). Note that once the conversation is closed, it will not be sent to a queue or agent.',
});

export const CloseNodeMessengerAttributes = createCloseNodeAttributes({
  iconName: 'close-circle-filled',
  label: 'Close',
  ActionModal: noModal(FlowNodeTypes.CLOSE, {
    text: 'Close messenger',
    isAction: false,
  }),
});

export const CloseNodeChatAttributes = createCloseNodeAttributes({
  iconName: 'arrow-down',
  label: 'Hide widget',
  ActionModal: CloseChatModal,
});

export const StopNodeAutomationAttributes = createCloseNodeAttributes({
  iconName: 'close',
  label: 'End automation',
  ActionModal: noModal(AutomationNodeTypes.STOP),
});

export const CloseNodeAutomationAttributes = createCloseNodeAttributes({
  iconName: 'close-circle-filled',
  label: 'Close conversation',
  ActionModal: noModal(AutomationNodeTypes.CLOSE),
  helpText:
    'Close the conversation entirely when it matches predetermined criteria (e.g. after a filter or tag is applied, after an auto-reply is sent, etc.). Note that once the conversation is closed, it will not be sent to a queue or agent.',
});

export function CloseNode(_props: CloseNodeProps): JSX.Element {
  return <></>;
}
